import { ErrorState } from '@/@types/error';

export const NOT_FOUND_STATUS: ErrorState = 'not_found';
export const SERVER_ERROR_STATUS: ErrorState = 'server_error';
export const UNKNOWN_ERROR_STATUS: ErrorState = 'unknown_error';
